export default {
    SET_LIST(state, notices) {
        state.list = notices;
    },
};
